import React, { Component } from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import Nav from './Components/Nav/Navigation.jsx';
import Home from './Components/DashBoard/Home';
import Login from './Components/Authorization/LoginPg';
import About from './Components/DashBoard/AboutPg';
import ErrorPg from './Components/DashBoard/ErrorBound';
import Profile from './Components/Accounts/Users';
import SignUp from './Components/Authorization/SignUpPg';
import CreateEvent from './Components/Events/NewEvent';
import Trips from './Components/Events/Trip';
import Event from './Components/Events/Event'

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Nav></Nav>
          <br />
         <Switch>
            <Route exact path='/' component={ Home } />
            <Route path='/login' component={ Login } />
            <Route path='/about' component={ About } />
            <Route path='/profile' component={ Profile } />
            <Route path='/newEvents' component={ CreateEvent } />
            <Route path='/trips' component={ Trips } />
            <Route path='/event/:eventID' component={ Event } />
            <Route path='/signup' component={ SignUp } />
            <Route component = {ErrorPg}/>
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;

